/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_Anon_AtInputs */

const cs_gdpr_review_anon_at = /** @type {(inputs: Gdpr_Review_Anon_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymizace`)
};

const en_gdpr_review_anon_at = /** @type {(inputs: Gdpr_Review_Anon_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymisation`)
};

/**
* | output |
* | --- |
* | "Anonymisation" |
*
* @param {Gdpr_Review_Anon_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_anon_at = /** @type {((inputs?: Gdpr_Review_Anon_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_Anon_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_anon_at(inputs)
	return cs_gdpr_review_anon_at(inputs)
});